/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_AddInputs */

const vi_vehicle_add = /** @type {(inputs: Vehicle_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm xe`)
};

/**

* @param {Vehicle_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_add = /** @type {((inputs?: Vehicle_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_add(inputs)
});